import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import NavLinksContainer from "./NavLinksContainer";
import NavPrompt from "./NavPrompt";
import NewChat from "./NewChat";
import { getUserID } from "../../Utility/service";
import { SidebarContext } from "../../contexts/SidebarContext";
import Scrollbars from "rc-scrollbars";
import { FaSearch } from "react-icons/fa";
import { categorizePrompts } from "../../Utility/helper";
import { getChatThread } from "../../api/threadApiFunctions";
import { AssistantContext } from "../../contexts/AssistantContext";
import AssistantList from "../layout/NewSidebar/AssistantList";
import { useNavigate, useParams } from "react-router-dom";
import debounce from "lodash/debounce";
import { LuLayers } from "react-icons/lu";
import "./exploreAssistant.css";
import { getSingleAssistant } from "../../api/assistantChatPageApi";
import "./NavBar.css";
import "./NavContentDuplicate.css";
import { FolderOpenOutlined } from "@ant-design/icons";
import { AiOutlineAntDesign } from "react-icons/ai";
import logo from "../../assests/images/NewLogo.png";
import darkLogo from "../../assests/images/NewLogo-dark.png";
import whiteLogo from "../../assests/images/qcc_logo.png";
import blackLogo from "../../assests/images/qcc_logo.png";
import { ThemeContext } from "../../contexts/themeConfig";
import { FaFolderOpen } from "react-icons/fa6";
import { BsFillLayersFill } from "react-icons/bs";
import CommonNavLinks from "../layout/NewSidebar/CommonNavLinks";
import { useTour } from "../../Utility/walkthrough/useTour";
import { PiFolderOpen } from "react-icons/pi";
import { LucideLayers3 } from "lucide-react";

const NavContentDuplicate = ({
}) => {
  const userid = getUserID();
  const { showTour, setShowTour } = useTour();
  const [_, setRender] = useState(0); 
  
  useEffect(() => {
    setRender((prev) => prev + 1); 
  }, [showTour]);
  
  const [chatThread, setChatThread] = useState([]);
  const {
    assistants,
    setAssistants,
    totalPage,
    setTotalPage,
    page,
    setPage,
    loading,
    setLoading,
    handleFetchAssistants,
    fetchSearchedAssistants,
    searchQuery,
    setSearchQuery,
    deletedAssistantThreadId,
    triggerUpdateThreads,
    setTriggerUpdateThreads,
    assistantSelected,
    setAssistantSelected,
    assistantIdLinked,
    setAssistantIdLinked,
    addAssistantName,
    setAddAssistantName,
  } = useContext(AssistantContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { assistant_id } = useParams();

  useEffect(() => {
    if (assistant_id) {
      setAssistantSelected(true);
      setAssistantIdLinked(assistant_id);
    } else {
      setAssistantSelected(false);
      setAssistantIdLinked("");
    }
    if (assistantIdLinked) {
      const fetchData = async () => {
        const res = await getSingleAssistant(assistantIdLinked);
        if (res?.assistant?.name) {
          setAddAssistantName(res.assistant.name);
        }
      };
      fetchData();
    }
  }, [assistantIdLinked, window.location.pathname]);

  const handleClick = (event) => {
    if (event.isTrusted) {
      navigate("/public-agent");
    }
  };

  const handleClickOnKnowledgeBase = () => {
    navigate("/knowledge-base");
  };

  const handleAssistantSearch = useCallback(
    debounce((value) => {
      setSearchQuery(value);
      setPage(1);
    }, 600),
    []
  );
  // Main sidebar end
  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-between">
      <div className="w-100 logo-wrapper">
        <img
          onClick={() => {
            navigate("/chat", { replace: true });
          }}
          alt="brand logo"
          src={theme === "light" ? blackLogo : whiteLogo}
          width="45"
          height="40"
        />
        <div style={{ padding: "6px", paddingBottom: 0, width:"200px" }}>
          <NewChat />
        </div>
      </div>
      <div className="h-100 w-100">
        <div
          onClick={handleClickOnKnowledgeBase}
          className="glyphicon glyphicon-th-large sidebar-item"
          id="knowledge-base-btn"
        >
          <p className="custom-size-for-explore-text fw-bold sidebar-text" style={{paddingTop:"12px"}}>
            <PiFolderOpen className="fs-5 me-2 sidebar-icon" />
            Knowledge Base
          </p>
        </div>
        <div
          
          onClick={handleClick}
          className="glyphicon glyphicon-th-large sidebar-item"
        >
          <p className="fw-bold custom-size-for-explore-text sidebar-text" id="explore-agents-btn" style={{marginBottom: "4px"}}>
            <LuLayers className="fs-5 me-2 sidebar-icon"  />
            Explore Agents
          </p>
        </div>

        <div style={{ padding: "0.875rem", paddingTop: 0 }}>
          <div className="d-flex w-100 align-items-center">
            <hr className="sidebar-hr" style={{ width: "50%" }} />
            <small
              style={{
                fontSize: "0.75rem",
                lineHeight: "1rem",
                padding: "0.5rem",
                whiteSpace: "nowrap",
              }}
              className="text-capitalize text-secondary"
            >
              Recents
            </small>
            <hr className="sidebar-hr" style={{ width: "50%" }} />
          </div>

          {/* <div className="input-group input-group-sm mb-1">
            <span className="input-group-text sidebar-search" id="basic-addon1">
              <FaSearch />
            </span>
            <input
              type="text"
              className="form-control sidebar-search"
              placeholder="Search Agent"
              aria-label="Agent Search"
              aria-describedby="basic-addon1"
              onChange={(e) => handleAssistantSearch(e?.target?.value)}
            />
          </div> */}

          <AssistantList
            propsData={{ 
              assistants,
              setAssistants,
              page,
              totalPage,
              loading,
              actions: {
                setPage,
              },
              setAssistantSelected,
              setAssistantIdLinked,
              handleFetchAssistants,
            }}
          />
        </div>
      </div>
      <CommonNavLinks />
      <NavLinksContainer showTour={showTour} chatLog={chatThread} setChatLog={setChatThread} />
    </div>
  );
};

export default NavContentDuplicate;
